import { FormControl } from "@mui/material";
import MUIRadioGroup from "@mui/material/RadioGroup";
import Stack, { type StackProps } from "@mui/material/Stack";
import { ErrorMessage, useField } from "formik";
import { type FC, type PropsWithChildren } from "react";
import { FormErrorMessage } from "@repo/ui";


export type RadioProps = PropsWithChildren<StackProps & {
	name: string;
	label?: string;
	spacing?: number;
}>

export const RadioGroup: FC<RadioProps> = ({
	children,
	label,
	name,
	sx,
	spacing,
	...rest
}) => {
	const [{ value }, { initialValue }] = useField(name);
	return (
		<Stack sx={sx} spacing={spacing} {...rest}>
			{label && <span>{label}</span>}
			<FormControl>
				<MUIRadioGroup
					aria-labelledby={`radio-buttons-group-${name}`}
					defaultValue={initialValue}
					value={value}
					name={name}
				>
					<Stack spacing={spacing}>{children}</Stack>
				</MUIRadioGroup>
			</FormControl>
			<ErrorMessage
				name={name}
				render={(msg) => <FormErrorMessage name={name}>{msg}</FormErrorMessage>}
			/>
		</Stack>
	);
};

